/**
 * Клас для перемикання табів (вкладок).
 * Відповідає за зміну активних класів, aria-атрибутів та показ відповідних панелей.
 */
export default class Tabs {
    /**
     * @param {HTMLElement} container - Головний контейнер з табами та панелями.
     * @param {Object} options - Налаштування.
     * @param {string} options.activeClass - Клас, який додається активному табу/панелі (за замовчуванням '_active').
     */
    constructor(container, options = {}) {
        if (!container) return;

        this.container = container;
        this.activeClass = options.activeClass || "_active";
        this.tabButtons = this.container.querySelectorAll('[role="tab"]');
        this.tabPanels = this.container.querySelectorAll('[role="tabpanel"]');

        if (!this.tabButtons.length || !this.tabPanels.length) return;

        this.init();
    }

    /**
     * Ініціалізація подій.
     */
    init() {
        this.tabButtons.forEach((button) => {
            button.addEventListener("click", (e) => this.switchTab(e.currentTarget));

            // Додаємо підтримку клавіатури (Enter / Space)
            button.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.switchTab(e.currentTarget);
                }
            });
        });
    }

    /**
     * Метод перемикання табів.
     * @param {HTMLElement} selectedTab - Кнопка таба, по якій клікнули.
     */
    switchTab(selectedTab) {
        const targetSelector = selectedTab.getAttribute("data-tab-target");
        const targetPanel = this.container.querySelector(targetSelector);

        if (!targetPanel || selectedTab.classList.contains(this.activeClass)) return;

        // 1. Деактивуємо всі таби та панелі
        this.tabButtons.forEach((btn) => {
            btn.classList.remove(this.activeClass);
            btn.setAttribute("aria-selected", "false");
        });

        this.tabPanels.forEach((panel) => {
            panel.classList.remove(this.activeClass);
        });

        // 2. Активуємо обраний таб та відповідну панель
        selectedTab.classList.add(this.activeClass);
        selectedTab.setAttribute("aria-selected", "true");
        targetPanel.classList.add(this.activeClass);
    }
}
